import { lazy } from "react"
import { Navigate, useParams } from "react-router-dom"
import { useAuth } from "@/features/auth/AuthContext"
import { portalEventDetailPath } from "@/app/router/portalRoutes"

const EventDetailPage = lazy(() => import("@/pages/events/EventDetailPage"))

/**
 * `/events/:id`: для гостя — карточка в общем layout без бокового меню кабинета;
 * для авторизованного — редирект в портал мероприятий.
 */
export function LegacyEventDetailRedirect() {
  const { id } = useParams<{ id: string }>()
  const { isAuthenticated } = useAuth()
  if (!id) return <Navigate to="/events" replace />
  if (isAuthenticated) return <Navigate to={portalEventDetailPath(id)} replace />
  return <EventDetailPage />
}
